import { InjectionToken } from '@angular/core';

export const APP_INSIGHTS_CONNECTION_STRING = new InjectionToken<string>('APP_INSIGHTS_CONNECTION_STRING', {
    providedIn: 'root',
    factory: () => '',
});
